import { IconDiscountBadge } from '../../../icon/IconDiscountBadge';
import { IntlPercentage } from '../../../intl/Intl';

type Props = {
  discountPercentage: number;
};

/**
 * rcprofi's discount medallion — the artwork and the percentage.
 *
 * It carries no size of its own: the mark fills whatever box it is dropped
 * into, and how large a medallion reads over the gallery's imagery is the
 * section's answer, held by `ProductGalleryDiscountBadge`.
 */
export function GalleryDiscountBadge({ discountPercentage }: Props) {
  return (
    <IconDiscountBadge>
      &#8208;
      <IntlPercentage value={String(discountPercentage)} />
    </IconDiscountBadge>
  );
}
